import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type BoardDetailsInfoCardHeaderProps = {
  isAdmin: boolean;
  onClickEdit: VoidFunction; // eslint-disable-line
};

const BoardDetailsInfoCardHeader: FC<BoardDetailsInfoCardHeaderProps> = ({
  isAdmin,
  onClickEdit,
}) => {
  const { t } = useTranslate();

  const handleEditBoard = () => {
    onClickEdit();
  };

  return (
    <div className="nk-block-head d-flex justify-content-between align-items-center flex-wrap">
      <div className="nk-block-head-content">
        <h5 className="nk-block-title title mb-0">{t('BasicData')}</h5>
      </div>

      {isAdmin && (
        <div className="form-group mb-0">
          <button
            type="button"
            className="btn btn-sm btn-dim btn-primary mb-0"
            onClick={handleEditBoard}
          >
            <em className="icon ni ni-edit" />
            <span>{t('Edit')}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default BoardDetailsInfoCardHeader;
